'use client';
import clsx from 'clsx';
import { type ComponentPropsWithoutRef } from 'react';
import { createPortal } from 'react-dom';
import { useIsMounted } from '../../hooks/useIsMounted';

type FullscreenOverlayProps = ComponentPropsWithoutRef<'div'> & {
  isOpen: boolean;
};

export function FullscreenOverlay({ isOpen, ...props }: FullscreenOverlayProps) {
  const mounted = useIsMounted();

  return mounted && isOpen
    ? createPortal(
        <div className={clsx('satellite')}>
          <div
            className={clsx(
              'fixed',
              'top-0',
              'w-screen',
              'transition-opacity',
              'duration-100',
              'z-[897]',
              'overflow-hidden',
              {
                'bg-black/40 h-screen opacity-100 block': isOpen,
                'bg-black/0 h-0 opacity-0 hidden': !isOpen,
              },
            )}
            {...props}
          />
        </div>,
        document.body,
      )
    : null;
}
